import React, { Component, createRef } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import './App.css';
import InfoMessage from './components/message/InfoMessage'
import { getCurrentResource } from './util/tools';
import { getUserInfo, canViewForm, getLanguage, getButtonMode } from './util/localStorage';
//import Message from './modal/message/Message';

import ConfirmationModalDialog from './components/modal/ConfirmationModalDialog'; 

import HelloPage from './pages/hello/HelloPage';
import BomMessagePage from './pages/message/BomMessagePage';
import ProfilePage from './pages/profile/ProfilePage';
import ElibriPage from './pages/elibri/ElibriPage';
import DbManagerPage from './pages/admin/DbManagerPage';
import OptionsPage from './pages/admin/OptionsPage';
import SystemInfoPage from './pages/admin/SystemInfoPage';
import ConverterPage from './pages/converter/ConverterPage';
import BookSupplyPage from './pages/booksupply/BookSupplyPage';

import AuthorityAuthorPage from './pages/plain/AuthorityAuthorPage';
import AuthorityPublisherPage from './pages/plain/AuthorityPublisherPage';
import BookPage from './pages/plain/BookPage';
import BookProdPage from './pages/plain/BookProdPage';
import ClassifierPage from './pages/plain/ClassifierPage';
import ConfirmationPage from './pages/plain/ConfirmationPage';
import ContactPage from './pages/plain/ContactPage';
import DerivativePage from './pages/plain/DerivativePage';
import DigitalStorePage from './pages/plain/DigitalStorePage';
import EstimationPage from './pages/plain/EstimationPage';
import EventPage from './pages/plain/EventPage';
import HonorPage from './pages/plain/HonorPage';
import LibraryPage from './pages/plain/LibraryPage';
import LocationPage from './pages/plain/LocationPage';
import MessagePage from './pages/plain/MessagePage';
import OfferPage from './pages/plain/OfferPage';
import OrderPage from './pages/plain/OrderPage';
import OrganizationPage from './pages/plain/OrganizationPage';
import ProcurementPage from './pages/plain/ProcurementPage';
import ProductPage from './pages/plain/ProductPage';
import ProviderPage from './pages/plain/ProviderPage';
import RequestPage from './pages/plain/RequestPage';
//import RolePage from './pages/plain/RolePage';
import TopicPage from './pages/plain/TopicPage';
import UserGroupPage from './pages/plain/UserGroupPage';
import UserPage from './pages/plain/UserPage';

import AuthorityAuthorPlainPage from './pages/plain/AuthorityAuthorPlainPage';
import AuthorityPublisherPlainPage from './pages/plain/AuthorityPublisherPlainPage';
import BookPlainPage from './pages/plain/BookPlainPage';
import BookPlainSpecialPage from './pages/plain/BookPlainSpecialPage';
import BookShopPlainPage from './pages/plain/BookShopPlainPage';
import ConfirmationPlainPage from './pages/plain/ConfirmationPlainPage';
import ContactPlainPage from './pages/plain/ContactPlainPage';
import DerivativePlainPage from './pages/plain/DerivativePlainPage';
import DigitalStorePlainPage from './pages/plain/DigitalStorePlainPage';
import EBookBankPlainPage from './pages/plain/EBookBankPlainPage';
import EBookReportPlainPage from './pages/plain/EBookReportPlainPage';
import EBookSupplierPlainPage from './pages/plain/EBookSupplierPlainPage';
import EstimationPlainPage from './pages/plain/EstimationPlainPage';
import EventPlainPage from './pages/plain/EventPlainPage';
import HonorPlainPage from './pages/plain/HonorPlainPage';
import LibraryPlainPage from './pages/plain/LibraryPlainPage';
import LocationPlainPage from './pages/plain/LocationPlainPage';
import MessagePlainPage from './pages/plain/MessagePlainPage';
import MReportPlainPage from './pages/plain/MReportPlainPage';
import OfferPlainPage from './pages/plain/OfferPlainPage';
import OrderPlainPage from './pages/plain/OrderPlainPage';
import OrganizationPlainPage from './pages/plain/OrganizationPlainPage';
import ProcurementPlainPage from './pages/plain/ProcurementPlainPage';
import ProductPlainPage from './pages/plain/ProductPlainPage';
import ProviderPlainPage from './pages/plain/ProviderPlainPage';
import RequestPlainPage from './pages/plain/RequestPlainPage';
import RolePlainPage from './pages/plain/RolePlainPage';
import TopicPlainPage from './pages/plain/TopicPlainPage';
import UserGroupPlainPage from './pages/plain/UserGroupPlainPage';
import UserPlainPage from './pages/plain/UserPlainPage';
import WorkPlainPage from './pages/plain/WorkPlainPage';

import AuthorityAuthorListPage from './pages/tableform/AuthorityAuthorListPage';
import AuthorityPublisherListPage from './pages/tableform/AuthorityPublisherListPage';
import BookListPage from './pages/tableform/BookListPage';
import BookShopListPage from './pages/tableform/BookShopListPage';
import ClassifierListPage from './pages/tableform/ClassifierListPage';
import ConfirmationListPage from './pages/tableform/ConfirmationListPage';
import ContactListPage from './pages/tableform/ContactListPage';
import DerivativeListPage from './pages/tableform/DerivativeListPage';
import DigitalStoreListPage from './pages/tableform/DigitalStoreListPage';
import EBookBankListPage from './pages/tableform/EBookBankListPage';
import EBookMerchantListPage from './pages/tableform/EBookMerchantListPage';
import EBookPaymentListPage from './pages/tableform/EBookPaymentListPage';
import EBookReportListPage from './pages/tableform/EBookReportListPage';
import EBookReportItemListPage from './pages/tableform/EBookReportItemListPage';
import EBookSupplierListPage from './pages/tableform/EBookSupplierListPage';
import EBookTerminalListPage from './pages/tableform/EBookTerminalListPage';
import EstimationListPage from './pages/tableform/EstimationListPage';
import EventListPage from './pages/tableform/EventListPage';
import HonorListPage from './pages/tableform/HonorListPage';
import LibraryListPage from './pages/tableform/LibraryListPage';
import LocationListPage from './pages/tableform/LocationListPage';
import LogListPage from './pages/tableform/LogListPage';
import MessageListPage from './pages/tableform/MessageListPage';
import MReportListPage from './pages/tableform/MReportListPage';
import MReportItemListPage from './pages/tableform/MReportItemListPage';
import OfferListPage from './pages/tableform/OfferListPage';
import OnixLogListPage from './pages/tableform/OnixLogListPage';
import OrderListPage from './pages/tableform/OrderListPage';
import OrganizationListPage from './pages/tableform/OrganizationListPage';
import ProcurementListPage from './pages/tableform/ProcurementListPage';
import ProductListPage from './pages/tableform/ProductListPage';
import ProviderListPage from './pages/tableform/ProviderListPage';
import RequestListPage from './pages/tableform/RequestListPage';
import RequestItemListPage from './pages/tableform/RequestItemListPage';
import RoleListPage from './pages/tableform/RoleListPage';
import TopicListPage from './pages/tableform/TopicListPage';
import UserGroupListPage from './pages/tableform/UserGroupListPage';
import UserListPage from './pages/tableform/UserListPage';
import WorkListPage from './pages/tableform/WorkListPage';

import KatottgPage from './pages/admin/KatottgPage';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';

import {
	ROOT_PATH,
	HELLO_PATH,
	ELIBRI_PATH,
	PROFILE_PATH,
	DBMANAGER_PATH,
	SYSTEM_OPTIONS_PATH,
	SYSINFO_PATH,

	AUTHORITY_AUTHOR_PATH,
	AUTHORITY_PUBLISHER_PATH,
	BOOK_PATH,
	BOOK_PROD_PATH,
	CLASSIFIER_PATH,
	CONFIRMATION_PATH,
	CONTACT_PATH,
	DERIVATIVE_PATH,
	DIGITAL_STORE_PATH,
	ESTIMATION_PATH,
	EVENT_PATH,
	HONOR_PATH,
	LIBRARY_PATH,
	MESSAGE_PATH,
	OFFER_PATH,
	ORDER_PATH,
	ORGANIZATION_PATH,
	LOCATION_PATH,
	PROCUREMENT_PATH,
	PRODUCT_PATH,
	PROVIDER_PATH,
	REQUEST_PATH,
	TOPIC_PATH,
	USER_GROUP_PATH,
	USER_PATH,
	
	AUTHORITY_AUTHOR_TABLE_PATH,
	AUTHORITY_PUBLISHER_TABLE_PATH,
	BOOK_TABLE_PATH,
	BOOKSHOP_TABLE_PATH,
	CLASSIFIER_TABLE_PATH,
	CONFIRMATION_TABLE_PATH,
	CONTACT_TABLE_PATH,
	DERIVATIVE_TABLE_PATH,
	DIGITAL_STORE_TABLE_PATH,
	EBOOK_BANK_TABLE_PATH,
	EBOOK_MERCHANT_TABLE_PATH,
	EBOOK_PAYMENT_TABLE_PATH,
	EBOOK_REPORT_TABLE_PATH,
	EBOOK_REPORT_ITEM_TABLE_PATH,
	EBOOK_SUPPLIER_TABLE_PATH,
	EBOOK_TERMINAL_TABLE_PATH,
	ESTIMATION_TABLE_PATH,
	EVENT_TABLE_PATH,
	HONOR_TABLE_PATH,
	KATOTTG_TREE_PATH,
	LIBRARY_TABLE_PATH,
	MESSAGE_TABLE_PATH,
	MREPORT_TABLE_PATH,
	MREPORT_ITEM_TABLE_PATH,
	OFFER_TABLE_PATH,
	ONIX_LOG_TABLE_PATH,
	ORDER_TABLE_PATH,
	ORGANIZATION_TABLE_PATH,
	LOCATION_TABLE_PATH,
	LOG_TABLE_PATH,
	PROCUREMENT_TABLE_PATH,
	PRODUCT_TABLE_PATH,
	PROVIDER_TABLE_PATH,
	REQUEST_TABLE_PATH,
	REQUEST_ITEM_TABLE_PATH,
	ROLE_TABLE_PATH,
	TOPIC_TABLE_PATH,
	USER_GROUP_TABLE_PATH,
	USER_TABLE_PATH,
	WORK_TABLE_PATH,
	
	AUTHORITY_AUTHOR_PLAIN_PATH,
	AUTHORITY_PUBLISHER_PLAIN_PATH,
	BOOK_PLAIN_PATH,
	BOOK_PLAIN_SPECIAL_PATH,
	BOOKSHOP_PLAIN_PATH,
	CONFIRMATION_PLAIN_PATH,
	CONTACT_PLAIN_PATH,
	DERIVATIVE_PLAIN_PATH,
	DIGITAL_STORE_PLAIN_PATH,
	EBOOK_BANK_PLAIN_PATH,
	EBOOK_REPORT_PLAIN_PATH,
	EBOOK_SUPPLIER_PLAIN_PATH,
	ESTIMATION_PLAIN_PATH,
	EVENT_PLAIN_PATH,
	HONOR_PLAIN_PATH,
	LIBRARY_PLAIN_PATH,
	LOCATION_PLAIN_PATH,
	MESSAGE_PLAIN_PATH,
	MREPORT_PLAIN_PATH,
	OFFER_PLAIN_PATH,
	ORDER_PLAIN_PATH,
	ORGANIZATION_PLAIN_PATH,
	PROCUREMENT_PLAIN_PATH,
	PRODUCT_PLAIN_PATH,
	PROVIDER_PLAIN_PATH,
	REQUEST_PLAIN_PATH,
	ROLE_PLAIN_PATH,
	TOPIC_PLAIN_PATH,
	USER_PLAIN_PATH,
	USER_GROUP_PLAIN_PATH,
	WORK_PLAIN_PATH,
	
	CONVERTER_PATH,
	BOOKSUPPLY_PATH
} from './util/routes';

import {
	FORM_AUTHORITY_AUTHOR_TABLE,
	FORM_AUTHORITY_PUBLISHER_TABLE,
	FORM_BOOK_TABLE,
	FORM_BOOKSHOP_TABLE,
	FORM_CLASSIFIER_TABLE,
	FORM_CONFIRMATION_TABLE,
	FORM_CONTACT_TABLE,
	FORM_DERIVATIVE_TABLE,
	FORM_DIGITAL_STORE_TABLE,
	FORM_EBOOK_BANK_TABLE,
	FORM_EBOOK_MERCHANT_TABLE,
	FORM_EBOOK_PAYMENT_TABLE,
	FORM_EBOOK_REPORT_TABLE,
	FORM_EBOOK_REPORT_ITEM_TABLE,
	FORM_EBOOK_SUPPLIER_TABLE,
	FORM_EBOOK_TERMINAL_TABLE,
	FORM_ESTIMATION_TABLE,
	FORM_EVENT_TABLE,
	FORM_HONOR_TABLE,
	FORM_KATOTTG_TREE,
	FORM_LIBRARY_TABLE,
	FORM_LOCATION_TABLE,
	FORM_LOG_TABLE,
	FORM_MESSAGE_TABLE,
	FORM_MREPORT_TABLE,
	FORM_MREPORT_ITEM_TABLE,
	FORM_OFFER_TABLE,
	FORM_ONIX_LOG_TABLE,
	FORM_ORDER_TABLE,
	FORM_ORGANIZATION_TABLE,
	FORM_PROCUREMENT_TABLE,
	FORM_PRODUCT_TABLE,
	FORM_PROVIDER_TABLE,
	FORM_REQUEST_TABLE,
	FORM_REQUEST_ITEM_TABLE,
	FORM_ROLE_TABLE,
	FORM_TOPIC_TABLE,
	FORM_USER_GROUP_TABLE,
	FORM_USER_TABLE,
	FORM_WORK_TABLE,

	FORM_AUTHORITY_AUTHOR_FT,
	FORM_AUTHORITY_PUBLISHER_FT,
	FORM_BOOK_FT,
	FORM_BOOK_PROD_FT,
	FORM_CLASSIFIER_FT,
	FORM_CONFIRMATION_FT,
	FORM_CONTACT_FT,
	FORM_DERIVATIVE_FT,
	FORM_DIGITAL_STORE_FT,
	FORM_ESTIMATION_FT,
	FORM_EVENT_FT,
	FORM_HONOR_FT,
	FORM_LIBRARY_FT,
	FORM_LOCATION_FT,	
	FORM_MESSAGE_FT,	
	FORM_OFFER_FT,
	FORM_ORDER_FT,
	FORM_ORGANIZATION_FT,
	FORM_PROCUREMENT_FT,
	FORM_PRODUCT_FT,
	FORM_PROVIDER_FT,
	FORM_REQUEST_FT,
	FORM_TOPIC_FT,
	FORM_USER_FT,
	FORM_USER_GROUP_FT,
	
	FORM_AUTHORITY_AUTHOR_PLAIN, 
	FORM_AUTHORITY_PUBLISHER_PLAIN, 
	FORM_BOOK_PLAIN,
	FORM_BOOK_SPECIAL_PLAIN,
	FORM_BOOKSHOP_PLAIN,
	FORM_CONFIRMATION_PLAIN,
	FORM_CONTACT_PLAIN,
	FORM_DERIVATIVE_PLAIN,
	FORM_DIGITAL_STORE_PLAIN,
	FORM_EBOOK_BANK_PLAIN,
	FORM_EBOOK_REPORT_PLAIN,
	FORM_EBOOK_SUPPLIER_PLAIN,
	FORM_ESTIMATION_PLAIN,
	FORM_EVENT_PLAIN,
	FORM_HONOR_PLAIN,
	FORM_LIBRARY_PLAIN,	
	FORM_LOCATION_PLAIN,
	FORM_MESSAGE_PLAIN,	
	FORM_MREPORT_PLAIN,	
	FORM_OFFER_PLAIN, 
	FORM_ORDER_PLAIN,
	FORM_ORGANIZATION_PLAIN,
	FORM_PROCUREMENT_PLAIN,
	FORM_PRODUCT_PLAIN,
	FORM_PROVIDER_PLAIN,
	FORM_REQUEST_PLAIN,
	FORM_ROLE_PLAIN,
	FORM_TOPIC_PLAIN,
	FORM_USER_PLAIN,
	FORM_USER_GROUP_PLAIN,
	FORM_WORK_PLAIN,
	
	FORM_DBMANAGER,
	FORM_OPTIONS
} from './util/consts/forms';

class App extends Component {

	constructor(props) {
		super(props);
		this.refInfoMessage = React.createRef();
		this.refConfirmDeleteModalDialog =  React.createRef(); 
		this.state = {
			isModalMessageOpen: false,
			lang: getLanguage(),
			buttonMode: getButtonMode()
		}
	}

	showResponse = (response, defaultMessage, doAfterClose) => {
		this.refInfoMessage.current.showResponse(response, defaultMessage, doAfterClose);
	}
	/*
		message : {
			title
			mainMessage
			additionalMessage
			maxWidth
		}
	*/
	showMessage = ( message, doAfterClose ) => {
		this.refInfoMessage.current.showMessage(message, doAfterClose);
	}

	render () {
		let userInfo = getUserInfo();
		console.log('UserInfo', userInfo);
		return (
			<Router>
				<div className="App">
					<InfoMessage ref={this.refInfoMessage} />
					<ConfirmationModalDialog ref={this.refConfirmDeleteModalDialog} />
					<Header />
					<Switch>
						<Route exact path={ROOT_PATH} render={() => <Redirect to={HELLO_PATH} />} />
						<AuthorizedRoute exact path={HELLO_PATH} component={props => <HelloPage {...props} />} app={this} />
						<AuthorizedRoute exact path={ELIBRI_PATH} component={props => <ElibriPage {...props} />} app={this} />
						<AuthorizedRoute exact path={PROFILE_PATH} component={props => <ProfilePage {...props} />} app={this} />

						{/* ========================================================================
							TABLES, TREE
						*/}
						<AuthorizedRoute exact path={AUTHORITY_AUTHOR_TABLE_PATH} 
							component={props => <AuthorityAuthorListPage {...props} />}
							form={FORM_AUTHORITY_AUTHOR_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${AUTHORITY_AUTHOR_TABLE_PATH}/:param`} 
							component={props => <AuthorityAuthorListPage {...props} />}
							form={FORM_AUTHORITY_AUTHOR_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={AUTHORITY_PUBLISHER_TABLE_PATH} 
							component={props => <AuthorityPublisherListPage {...props} />} 
							form={FORM_AUTHORITY_PUBLISHER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${AUTHORITY_PUBLISHER_TABLE_PATH}/:param`} 
							component={props => <AuthorityPublisherListPage {...props} />} 
							form={FORM_AUTHORITY_PUBLISHER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={BOOK_TABLE_PATH} 
							component={props => <BookListPage {...props} />} 
							form={FORM_BOOK_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOK_TABLE_PATH}/:param`} 
							component={props => <BookListPage {...props} />} 
							form={FORM_BOOK_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={BOOKSHOP_TABLE_PATH} 
							component={props => <BookShopListPage {...props} />} 
							form={FORM_BOOKSHOP_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOKSHOP_TABLE_PATH}/:param`} 
							component={props => <BookShopListPage {...props} />} 
							form={FORM_BOOKSHOP_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={CLASSIFIER_TABLE_PATH} 
							component={props => <ClassifierListPage {...props} />} 
							form={FORM_CLASSIFIER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CLASSIFIER_TABLE_PATH}/:param`} 
							component={props => <ClassifierListPage {...props} />} 
							form={FORM_CLASSIFIER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={CONFIRMATION_TABLE_PATH} 
							component={props => <ConfirmationListPage {...props} />} 
							form={FORM_CONFIRMATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CONFIRMATION_TABLE_PATH}/:param`} 
							component={props => <ConfirmationListPage {...props} />} 
							form={FORM_CONFIRMATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={CONTACT_TABLE_PATH} 
							component={props => <ContactListPage {...props} />} 
							form={FORM_CONTACT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CONTACT_TABLE_PATH}/:param`} 
							component={props => <ContactListPage {...props} />} 
							form={FORM_CONTACT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={DERIVATIVE_TABLE_PATH} 
							component={props => <DerivativeListPage {...props} />} 
							form={FORM_DERIVATIVE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${DERIVATIVE_TABLE_PATH}/:param`} 
							component={props => <DerivativeListPage {...props} />} 
							form={FORM_DERIVATIVE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={DIGITAL_STORE_TABLE_PATH} 
							component={props => <DigitalStoreListPage {...props} />} 
							form={FORM_DIGITAL_STORE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${DIGITAL_STORE_TABLE_PATH}/:param`} 
							component={props => <DigitalStoreListPage {...props} />} 
							form={FORM_DIGITAL_STORE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_BANK_TABLE_PATH}`} 
							component={props => <EBookBankListPage {...props} />}
							form={FORM_EBOOK_BANK_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_BANK_TABLE_PATH}/:param`} 
							component={props => <EBookBankListPage {...props} />}
							form={FORM_EBOOK_BANK_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_MERCHANT_TABLE_PATH}`} 
							component={props => <EBookMerchantListPage {...props} />}
							form={FORM_EBOOK_MERCHANT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_MERCHANT_TABLE_PATH}/:param`} 
							component={props => <EBookMerchantListPage {...props} />}
							form={FORM_EBOOK_MERCHANT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_PAYMENT_TABLE_PATH}`} 
							component={props => <EBookPaymentListPage {...props} />}
							form={FORM_EBOOK_PAYMENT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_PAYMENT_TABLE_PATH}/:param`} 
							component={props => <EBookPaymentListPage {...props} />}
							form={FORM_EBOOK_PAYMENT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_BANK_TABLE_PATH}/:param`} 
							component={props => <EBookBankListPage {...props} />}
							form={FORM_EBOOK_BANK_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_REPORT_TABLE_PATH}`} 
							component={props => <EBookReportListPage {...props} />}
							form={FORM_EBOOK_REPORT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_REPORT_TABLE_PATH}/:param`} 
							component={props => <EBookReportListPage {...props} />}
							form={FORM_EBOOK_REPORT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_REPORT_ITEM_TABLE_PATH}`} 
							component={props => <EBookReportItemListPage {...props} />}
							form={FORM_EBOOK_REPORT_ITEM_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_REPORT_ITEM_TABLE_PATH}/:param`} 
							component={props => <EBookReportItemListPage {...props} />}
							form={FORM_EBOOK_REPORT_ITEM_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MREPORT_TABLE_PATH}`} 
							component={props => <MReportListPage {...props} />}
							form={FORM_MREPORT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MREPORT_TABLE_PATH}/:param`} 
							component={props => <MReportListPage {...props} />}
							form={FORM_MREPORT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MREPORT_ITEM_TABLE_PATH}`} 
							component={props => <MReportItemListPage {...props} />}
							form={FORM_MREPORT_ITEM_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MREPORT_ITEM_TABLE_PATH}/:param`} 
							component={props => <MReportItemListPage {...props} />}
							form={FORM_MREPORT_ITEM_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_SUPPLIER_TABLE_PATH}`} 
							component={props => <EBookSupplierListPage {...props} />}
							form={FORM_EBOOK_SUPPLIER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_SUPPLIER_TABLE_PATH}/:param`} 
							component={props => <EBookSupplierListPage {...props} />}
							form={FORM_EBOOK_SUPPLIER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_TERMINAL_TABLE_PATH}`} 
							component={props => <EBookTerminalListPage {...props} />}
							form={FORM_EBOOK_TERMINAL_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_TERMINAL_TABLE_PATH}/:param`} 
							component={props => <EBookTerminalListPage {...props} />}
							form={FORM_EBOOK_TERMINAL_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={ESTIMATION_TABLE_PATH} 
							component={props => <EstimationListPage {...props} />}
							form={FORM_ESTIMATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ESTIMATION_TABLE_PATH}/:param`} 
							component={props => <EstimationListPage {...props} />}
							form={FORM_ESTIMATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={EVENT_TABLE_PATH} 
							component={props => <EventListPage {...props} />}
							form={FORM_EVENT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EVENT_TABLE_PATH}/:param`} 
							component={props => <EventListPage {...props} />}
							form={FORM_EVENT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={HONOR_TABLE_PATH} 
							component={props => <HonorListPage {...props} />} 
							form={FORM_HONOR_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${HONOR_TABLE_PATH}/:param`} 
							component={props => <HonorListPage {...props} />} 
							form={FORM_HONOR_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={KATOTTG_TREE_PATH} 
							component={props => <KatottgPage {...props} />} 
							form={FORM_KATOTTG_TREE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={LIBRARY_TABLE_PATH} 
							component={props => <LibraryListPage {...props} />} 
							form={FORM_LIBRARY_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LIBRARY_TABLE_PATH}/:param`} 
							component={props => <LibraryListPage {...props} />} 
							form={FORM_LIBRARY_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={MESSAGE_TABLE_PATH} 
							component={props => <MessageListPage {...props} />} 
							form={FORM_MESSAGE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MESSAGE_TABLE_PATH}/:param`} 
							component={props => <MessageListPage {...props} />} 
							form={FORM_MESSAGE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={OFFER_TABLE_PATH} 
							component={props => <OfferListPage {...props} />} 
							form={FORM_OFFER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${OFFER_TABLE_PATH}/:param`}
							component={props => <OfferListPage {...props} />} 
							form={FORM_OFFER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={ONIX_LOG_TABLE_PATH} 
							component={props => <OnixLogListPage {...props} />} 
							form={FORM_ONIX_LOG_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ONIX_LOG_TABLE_PATH}/:param`}
							component={props => <OnixLogListPage {...props} />} 
							form={FORM_ONIX_LOG_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={ORDER_TABLE_PATH} 
							component={props => <OrderListPage {...props} />} 
							form={FORM_ORDER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ORDER_TABLE_PATH}/:param`} 
							component={props => <OrderListPage {...props} />} 
							form={FORM_ORDER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={ORGANIZATION_TABLE_PATH} 
							component={props => <OrganizationListPage {...props} />} 
							form={FORM_ORGANIZATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ORGANIZATION_TABLE_PATH}/:param`} 
							component={props => <OrganizationListPage {...props} />} 
							form={FORM_ORGANIZATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={LOCATION_TABLE_PATH} 
							component={props => <LocationListPage {...props} />} 
							form={FORM_LOCATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LOCATION_TABLE_PATH}/:param`} 
							component={props => <LocationListPage {...props} />} 
							form={FORM_LOCATION_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={LOG_TABLE_PATH} 
							component={props => <LogListPage {...props} />} 
							form={FORM_LOG_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LOG_TABLE_PATH}/:param`} 
							component={props => <LogListPage {...props} />} 
							form={FORM_LOG_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={PROCUREMENT_TABLE_PATH} 
							component={props => <ProcurementListPage {...props} />} 
							form={FORM_PROCUREMENT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PROCUREMENT_TABLE_PATH}/:param`} 
							component={props => <ProcurementListPage {...props} />} 
							form={FORM_PROCUREMENT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={PRODUCT_TABLE_PATH} 
							component={props => <ProductListPage {...props} />} 
							form={FORM_PRODUCT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PRODUCT_TABLE_PATH}/:param`} 
							component={props => <ProductListPage {...props} />} 
							form={FORM_PRODUCT_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={PROVIDER_TABLE_PATH} 
							component={props => <ProviderListPage {...props} />} 
							form={FORM_PROVIDER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PROVIDER_TABLE_PATH}/:param`} 
							component={props => <ProviderListPage {...props} />} 
							form={FORM_PROVIDER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={REQUEST_TABLE_PATH} 
							component={props => <RequestListPage {...props} />} 
							form={FORM_REQUEST_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${REQUEST_TABLE_PATH}/:param`} 
							component={props => <RequestListPage {...props} />} 
							form={FORM_REQUEST_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={REQUEST_ITEM_TABLE_PATH} 
							component={props => <RequestItemListPage {...props} />} 
							form={FORM_REQUEST_ITEM_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${REQUEST_ITEM_TABLE_PATH}/:param`} 
							component={props => <RequestItemListPage {...props} />} 
							form={FORM_REQUEST_ITEM_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={ROLE_TABLE_PATH} 
							component={props => <RoleListPage {...props} />} 
							form={FORM_ROLE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ROLE_TABLE_PATH}/:param`} 
							component={props => <RoleListPage {...props} />} 
							form={FORM_ROLE_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={TOPIC_TABLE_PATH} 
							component={props => <TopicListPage {...props} />} 
							form={FORM_TOPIC_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${TOPIC_TABLE_PATH}/:param`} 
							component={props => <TopicListPage {...props} />} 
							form={FORM_TOPIC_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={USER_GROUP_TABLE_PATH} 
							component={props => <UserGroupListPage {...props} />} 
							form={FORM_USER_GROUP_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${USER_GROUP_TABLE_PATH}/:param`} 
							component={props => <UserGroupListPage {...props} />} 
							form={FORM_USER_GROUP_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={USER_TABLE_PATH} 
							component={props => <UserListPage {...props} />} 
							form={FORM_USER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${USER_TABLE_PATH}/:param`} 
							component={props => <UserListPage {...props} />} 
							form={FORM_USER_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={WORK_TABLE_PATH} 
							component={props => <WorkListPage {...props} />} 
							form={FORM_WORK_TABLE} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${WORK_TABLE_PATH}/:param`} 
							component={props => <WorkListPage {...props} />} 
							form={FORM_WORK_TABLE} 
							app={this} 
						/>


						{/* ========================================================================
							FIELD TREE
						*/}
						<AuthorizedRoute exact path={`${AUTHORITY_AUTHOR_PATH}/:id`} 
							component={props => <AuthorityAuthorPage {...props} />} 
							form={FORM_AUTHORITY_AUTHOR_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${AUTHORITY_PUBLISHER_PATH}/:id`} 
							component={props => <AuthorityPublisherPage {...props} />} 
							form={FORM_AUTHORITY_PUBLISHER_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOK_PATH}/:id`} 
							component={props => <BookPage {...props} />} 
							form={FORM_BOOK_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOK_PROD_PATH}/:id`} 
							component={props => <BookProdPage {...props} />} 
							form={FORM_BOOK_PROD_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CLASSIFIER_PATH}/:id`} 
							component={props => <ClassifierPage {...props} />} 
							form={FORM_CLASSIFIER_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CONFIRMATION_PATH}/:id`} 
							component={props => <ConfirmationPage {...props} />} 
							form={FORM_CONFIRMATION_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CONTACT_PATH}/:id`} 
							component={props => <ContactPage {...props} />} 
							form={FORM_CONTACT_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${DERIVATIVE_PATH}/:id`} 
							component={props => <DerivativePage {...props} />} 
							form={FORM_DERIVATIVE_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${DIGITAL_STORE_PATH}/:id`} 
							component={props => <DigitalStorePage {...props} />} 
							form={FORM_DIGITAL_STORE_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ESTIMATION_PATH}/:id`} 
							component={props => <EstimationPage {...props} />} 
							form={FORM_ESTIMATION_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EVENT_PATH}/:id`} 
							component={props => <EventPage {...props} />} 
							form={FORM_EVENT_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EVENT_PATH}/plain/:id`} 
							component={props => <EventPlainPage {...props} />} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${HONOR_PATH}/:id`} 
							component={props => <HonorPage {...props} />} 
							form={FORM_HONOR_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LIBRARY_PATH}/:id`} 
							component={props => <LibraryPage {...props} />} 
							form={FORM_LIBRARY_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MESSAGE_PATH}/:id`} 
							component={props => <MessagePage {...props} />} 
							form={FORM_MESSAGE_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${OFFER_PATH}/:id`} 
							component={props => <OfferPage {...props} />} 
							form={FORM_OFFER_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ORDER_PATH}/:id`} 
							component={props => <OrderPage {...props} />} 
							form={FORM_ORDER_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ORGANIZATION_PATH}/:id`} 
							component={props => <OrganizationPage {...props} />} 
							form={FORM_ORGANIZATION_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LOCATION_PATH}/:id`} 
							component={props => <LocationPage {...props} />} 
							form={FORM_LOCATION_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PROCUREMENT_PATH}/:id`} 
							component={props => <ProcurementPage {...props} />} 
							form={FORM_PROCUREMENT_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PRODUCT_PATH}/:id`} 
							component={props => <ProductPage {...props} />} 
							form={FORM_PRODUCT_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PROVIDER_PATH}/:id`} 
							component={props => <ProviderPage {...props} />} 
							form={FORM_PROVIDER_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${REQUEST_PATH}/:id`} 
							component={props => <RequestPage {...props} />} 
							form={FORM_REQUEST_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${TOPIC_PATH}/:id`} 
							component={props => <TopicPage {...props} />} 
							form={FORM_TOPIC_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${TOPIC_PATH}/:id/:param`} 
							component={props => <TopicPage {...props} />} 
							form={FORM_TOPIC_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${USER_GROUP_PATH}/:id`} 
							component={props => <UserGroupPage {...props} />} 
							form={FORM_USER_FT} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${USER_PATH}/:id`} 
							component={props => <UserPage {...props} />} 
							form={FORM_USER_GROUP_FT} 
							app={this} 
						/>

						{/* ========================================================================
							PLAIN
						*/}
 						<AuthorizedRoute exact path={`${AUTHORITY_AUTHOR_PLAIN_PATH}/:id`} 
							component={props => <AuthorityAuthorPlainPage {...props} />} 
							form={FORM_AUTHORITY_AUTHOR_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${AUTHORITY_PUBLISHER_PLAIN_PATH}/:id`} 
							component={props => <AuthorityPublisherPlainPage {...props} />} 
							form={FORM_AUTHORITY_PUBLISHER_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOK_PLAIN_PATH}/:id`} 
							component={props => <BookPlainPage {...props} />} 
							form={FORM_BOOK_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOK_PLAIN_SPECIAL_PATH}/:id`} 
							component={props => <BookPlainSpecialPage {...props} />} 
							form={FORM_BOOK_SPECIAL_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${BOOKSHOP_PLAIN_PATH}/:id`} 
							component={props => <BookShopPlainPage {...props} />} 
							form={FORM_BOOKSHOP_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CONFIRMATION_PLAIN_PATH}/:id`} 
							component={props => <ConfirmationPlainPage {...props} />} 
							form={FORM_CONFIRMATION_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${CONTACT_PLAIN_PATH}/:id`} 
							component={props => <ContactPlainPage {...props} />} 
							form={FORM_CONTACT_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${DERIVATIVE_PLAIN_PATH}/:id`} 
							component={props => <DerivativePlainPage {...props} />} 
							form={FORM_DERIVATIVE_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${DIGITAL_STORE_PLAIN_PATH}/:id`} 
							component={props => <DigitalStorePlainPage {...props} />} 
							form={FORM_DIGITAL_STORE_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_BANK_PLAIN_PATH}/:id`} 
							component={props => <EBookBankPlainPage {...props} />} 
							form={FORM_EBOOK_BANK_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_REPORT_PLAIN_PATH}/:id`} 
							component={props => <EBookReportPlainPage {...props} />} 
							form={FORM_EBOOK_REPORT_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EBOOK_SUPPLIER_PLAIN_PATH}/:id`} 
							component={props => <EBookSupplierPlainPage {...props} />} 
							form={FORM_EBOOK_SUPPLIER_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ESTIMATION_PLAIN_PATH}/:id`} 
							component={props => <EstimationPlainPage {...props} />} 
							form={FORM_ESTIMATION_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${EVENT_PLAIN_PATH}/:id`} 
							component={props => <EventPlainPage {...props} />} 
							form={FORM_EVENT_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${HONOR_PLAIN_PATH}/:id`} 
							component={props => <HonorPlainPage {...props} />} 
							form={FORM_HONOR_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LIBRARY_PLAIN_PATH}/:id`} 
							component={props => <LibraryPlainPage {...props} />} 
							form={FORM_LIBRARY_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${LOCATION_PLAIN_PATH}/:id`} 
							component={props => <LocationPlainPage {...props} />} 
							form={FORM_LOCATION_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MESSAGE_PLAIN_PATH}/:id`} 
							component={props => <MessagePlainPage {...props} />} 
							form={FORM_MESSAGE_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${MREPORT_PLAIN_PATH}/:id`} 
							component={props => <MReportPlainPage {...props} />} 
							form={FORM_MREPORT_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${OFFER_PLAIN_PATH}/:id`} 
							component={props => <OfferPlainPage {...props} />} 
							form={FORM_OFFER_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ORDER_PLAIN_PATH}/:id`} 
							component={props => <OrderPlainPage {...props} />} 
							form={FORM_ORDER_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ORGANIZATION_PLAIN_PATH}/:id`} 
							component={props => <OrganizationPlainPage {...props} />} 
							form={FORM_ORGANIZATION_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PROCUREMENT_PLAIN_PATH}/:id`} 
							component={props => <ProcurementPlainPage {...props} />} 
							form={FORM_PROCUREMENT_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PRODUCT_PLAIN_PATH}/:id`} 
							component={props => <ProductPlainPage {...props} />} 
							form={FORM_PRODUCT_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${PROVIDER_PLAIN_PATH}/:id`} 
							component={props => <ProviderPlainPage {...props} />} 
							form={FORM_PROVIDER_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${REQUEST_PLAIN_PATH}/:id`} 
							component={props => <RequestPlainPage {...props} />} 
							form={FORM_REQUEST_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${ROLE_PLAIN_PATH}/:id`} 
							component={props => <RolePlainPage {...props} />} 
							form={FORM_ROLE_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${TOPIC_PLAIN_PATH}/:id`} 
							component={props => <TopicPlainPage {...props} />} 
							form={FORM_TOPIC_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${USER_PLAIN_PATH}/:id`} 
							component={props => <UserPlainPage {...props} />} 
							form={FORM_USER_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${USER_GROUP_PLAIN_PATH}/:id`} 
							component={props => <UserGroupPlainPage {...props} />} 
							form={FORM_USER_GROUP_PLAIN} 
							app={this} 
						/>
						<AuthorizedRoute exact path={`${WORK_PLAIN_PATH}/:id`} 
							component={props => <WorkPlainPage {...props} />} 
							form={FORM_WORK_PLAIN} 
							app={this} 
						/>

						<AuthorizedRoute exact path={DBMANAGER_PATH} 
							component={DbManagerPage}
							form={FORM_DBMANAGER} 
							app={this} 
						/>
						<AuthorizedRoute exact path={SYSTEM_OPTIONS_PATH} 
							component={OptionsPage}
							form={FORM_OPTIONS} 
							app={this} 
						/>
						<AuthorizedRoute exact path={SYSINFO_PATH} 
							component={SystemInfoPage}
							form={FORM_DBMANAGER} 
							app={this} 
						/>
						<AuthorizedRoute exact path={CONVERTER_PATH} component={ConverterPage} />
						<AuthorizedRoute exact path={BOOKSUPPLY_PATH} component={BookSupplyPage} />
					</Switch>
					<Footer />
				</div>
			</Router>
		);
	}
}

function AuthorizedRoute({ component: Component, ...rest }) {
	let resource = getCurrentResource().App;
	let userInfo = getUserInfo();
	let isAllowed = false;
	if( userInfo.permission.superuser ) {
		isAllowed = true;
	} else {
		if( rest.form == null ) {
			if( rest.path == HELLO_PATH || rest.path == PROFILE_PATH)
				isAllowed = true;
			else
				isAllowed = false;
		} else {
			isAllowed = canViewForm(rest.form, userInfo);
		}
	}
	
	if( ! isAllowed ) {
		return (
			<Route {...rest} render={<BomMessagePage app={rest.app} message={resource.msgAccessDenied} /> } />
		);
	}

//	if( rest.path.startsWith( EBOOK_REPORT_PLAIN_PATH ) ) {
//		return (
//			<Route {...rest} render={props => <EBookReportEntityTablePlainPage {...props} app={rest.app} /> } />
//		);
//	}
	
	return (
		<Route {...rest} render={props => <Component {...props} app={rest.app} /> } />
	);
}

export default App;
